/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_TypeInputs */



/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Community_Link_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_type = /** @type {((inputs?: Community_Link_TypeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_TypeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plateforme")
	if (locale === "es") return /** @type {LocalizedString} */ ("Plataforma")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Plataforma")
	if (locale === "it") return /** @type {LocalizedString} */ ("Piattaforma")
	return /** @type {LocalizedString} */ ("Platform")
});